const TestTube02Icon = /*#__PURE__*/ [
  ["path", { d: "M16 2V18C16 20.2091 14.2091 22 12 22C9.79086 22 8 20.2091 8 18V2", stroke: "currentColor", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M8 8.55626C8.88889 7.40291 10.3106 8.23432 12 9.31817C14.2222 10.7439 15.5556 9.65003 16 8.6152", stroke: "currentColor", strokeLinecap: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M7 2H17", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }],
  ["path", { d: "M11 18.002L11.0087 17.9996", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", key: "3" }],
  ["path", { d: "M13 14.002L13.0087 13.9996", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "2", key: "4" }]
];

export { TestTube02Icon as default };
//# sourceMappingURL=TestTube02Icon.js.map
